<div class="rounded md:rounded-full {{type}} {{size}} py-0.5 px-1.5 content-center text-center">
  {{ label }}
</div>